import Loadable from '../components/Loadable/Loadable';
import type { Route } from '../types/router';

/**
 * Permission management routes
 *
 * These routes provide access to the permission management UI for:
 * - Resource Groups: CRUD operations for grouping related permissions
 * - Roles: CRUD operations for roles and their resource group assignments
 */
const permissionRoutes: Route[] = [
  {
    path: 'system/permissions',
    name: 'Permissions',
    component: Loadable({
      loader: () => import('../modules/permissions/PermissionsPage'),
    }),
    meta: {
      title: 'Permissions',
      roles: ['admin'],
    },
  },
  {
    path: 'system/permissions/resource-groups/create',
    name: 'Resource Group creation',
    component: Loadable({
      loader: () => import('../modules/permissions/ResourceGroupCreate'),
    }),
    meta: {
      title: 'Create Resource Group',
      roles: ['admin'],
    },
  },
  {
    path: 'system/permissions/resource-groups/:id',
    name: 'Resource Group update',
    component: Loadable({
      loader: () => import('../modules/permissions/ResourceGroupUpdate'),
    }),
    meta: {
      title: 'Update Resource Group',
      roles: ['admin'],
    },
  },
  {
    path: 'system/permissions/roles/create',
    name: 'Role creation',
    component: Loadable({
      loader: () => import('../modules/permissions/RoleCreate'),
    }),
    meta: {
      title: 'Create Role',
      roles: ['admin'],
    },
  },
  {
    path: 'system/permissions/roles/:id',
    name: 'Role update',
    component: Loadable({
      loader: () => import('../modules/permissions/RoleUpdate'),
    }),
    meta: {
      title: 'Update Role',
      roles: ['admin'],
    },
  },
];

export { permissionRoutes };
